import React from 'react'
import {findDOMNode} from "react-dom"

import {addClass, removeClass} from "../../core/gd/utils/dom-and-react/react-utils"

type Props = {

}

type State = {
    isOpen      : boolean,
    styles      : any,
    component   : any,
}

// const debug = "UIRightPanelMain"
const debug = false

export default class UIRightPanelMain extends React.Component<Props,State> {

    public app: any
    private node: any

    constructor(props: Props) {
        super(props)

        this.state = {
            isOpen      : false,
            component   : false,
            styles      : undefined
        }
    }

    componentDidMount() {
        this.node = findDOMNode(this)
        gd.layout.rightMain = this
    }

    reRender = () => {
        this.forceUpdate()
    }

    get isOpen() {
        return this.state.isOpen
    }

    get panelComponent() {
        return this.state.component
    }

    hide = () => {

        this.destroyApp()

        // do nothing if not needed
        if (!this.state.isOpen && !this.state.component) {
            return
        }

        this.setState({
            isOpen      : false,
            component   : false,
            styles      : undefined
        })
    }

    show = (component: any, styles = {}) => {

        this.destroyApp()

        this.setState({
            component   : component,
            isOpen      : true,
            styles      : styles
        })
    }

    // New Used in AI chat
    async loadAndRun(LoaderClass:any) {

        this.setState({
            component   : null,
            isOpen      : true
        }, ()=> {
            // gd.bus.triggerEvent('ui-right-panel:show', null)
        })

        debug && console.log(debug, "Right panel main loadAndRun()","App=",LoaderClass)

        if (!LoaderClass) {
            throw Error("UIRightPanelMain: LoaderClass is broken")
        }

        // ResourceLoaderProto
        const resourceLoader = new LoaderClass()

        try {
            const App = await resourceLoader.load()

            this.launchApp(App, {
                domContainerId: "ui-right-main"
            })

        } catch (e) {
            console.error(e, "UIRightPanelMain: something is wrong in app loading...")
        }
    }

    // New Used in AI chat
    async launchApp(AppClass : any,params:any={}):Promise<any> {

        gd.appManager.destroyModal()
        gd.appManager.destroyItemView(/*{onAppLaunch: true}*/)
        gd.appManager.destroyAnalytics()
        gd.appManager.destroyFullModal()

        try {
            addClass(this.node, 'is-app')
            this.app = new AppClass(params)

            await this.app.init(params)

            this.app.start();

        } catch (e) {
            console.error(e)
        }
    }

    destroyApp() {
        debug && console.log(debug,".destroyApp()", this.app);

        removeClass(this.node, 'is-app')

        if (!!this.app?.destructor) {
            this.app.destructor()
        }

        this.app = null
    }

    render() {
        if (!this.state.isOpen) {
            return (
                <div id         = "ui-right-main"
                     className  = "ui-right-main hidden"
                />
            )
        }

        if (this.state.isOpen) {
            return (
                <div  id        = "ui-right-main"
                      className = "ui-right-main open"
                      style     = {this.state.styles}
                >
                    {this.state.component}
                </div>
            )
        }
    }
}

